export const daysList = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const formatOptionLabel = ({ label, code }) => (
  <div>
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <span>{label}</span>
    </div>
    <span style={{ fontWeight: 600 }}>{code}</span>
  </div>
);

export const customFilterOption = (option, inputValue) => {
  const { label, code } = option.data;
  const search = inputValue.toLowerCase();

  return (
    label.toLowerCase().includes(search) || code?.toLowerCase().includes(search)
  );
};

export const staticArr = [
  {
    type: "signed_document",
    label: "Signed Document",
    apiName: "Signed Documents",
  },
  {
    type: "hotel_proof",
    label: "Hotel Proof",
    apiName: "Hotels Proof",
  },
  {
    type: "personal_proof_front",
    label: "Personal Proof Front",
    apiName: "Personal Proof - Front",
  },
  {
    type: "personal_proof_back",
    label: "Personal Proof Back",
    apiName: "Personal Proof - Back",
  },
];
